/**
 * This is extracted from `publicCollectionItemSchema.ts` to avoid circular dependencies.
 */

import { CategoryId_Schema } from "@/services/collection/categories";
import { CollectionItemId_Schema } from "@/services/collection/item/collectionItemIdSchema";
import { ApiResponse_Image_Schema } from "@/services/images";
import { WholeNumber_Schema } from "@/utilities/schema";
import { z } from "zod";

export const PublicCollectionItem_Basics_Schema = z
  .object({
    id: CollectionItemId_Schema,
    category: CategoryId_Schema,
    likesCount: WholeNumber_Schema,
    likedByCurrentUser: z.boolean(),
    images: ApiResponse_Image_Schema.array(),
  })
  .transform(({ category, ...rest }) => ({
    categoryId: category,
    ...rest,
  }));
